import React from "react";
import {
    PublicClientApplication, EventType
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./Authorization.jsx"

const pca =
    await PublicClientApplication.createPublicClientApplication(msalConfig);

// Process AAD redirect BEFORE React Router mounts.
// With HashRouter this used to look like /#code=... and become a garbage route.
const redirectResult = await pca.handleRedirectPromise();
if (redirectResult?.account) {
    pca.setActiveAccount(redirectResult.account);
} else {
    const accounts = pca.getAllAccounts();
    if (!pca.getActiveAccount() && accounts.length > 0) {
        pca.setActiveAccount(accounts[0]);
    }
}

// If a leftover auth fragment remains, strip it so the URL is clean.
const hash = window.location.hash || "";
if (hash.includes("code=") || hash.includes("error=") || hash.includes("client_info=")) {
    window.history.replaceState(
        null,
        document.title,
        `${window.location.pathname}${window.location.search}`
    );
}

pca.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        pca.setActiveAccount(event.payload.account);
    }
});

export const MsalWrapper = ({ children }) => {
    return (
        <MsalProvider instance={pca}>
            {children}
        </MsalProvider>
    );
};
